export default {
  TitleForm: 'Thông tin bổ sung',
  ProjectName: 'Tên dự án',
  ProjectCode: 'Mã dự án',
  Investor: 'Chủ đầu tư',
  BudgetCode: 'Mã ĐVQHNS',
  NameProject: 'CTMT, dự án',
  CodeProject: 'Mã CTMT, DA',
  SpendNo: 'Số CKC, HĐTH',
  NSYear: 'Năm NS',
  LetterPaymentCapital: 'Căn cứ Giấy đề nghị thanh toán vốn đầu tư số',
  Date: 'Ngày',
  KHVYear: 'Năm KHV',
  CashWitdDraw: 'Nghiệp vụ',
  AdvanceToExpense: 'Tạm ứng sang thực chi',
  NoDKTTToDKTT: 'Ứng trước chưa đủ ĐKTT sang ứng trước đủ ĐKTT',
  Agree: 'Đồng ý',
  Cancel: 'Hủy',
};
